import React from 'react';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button';
import { Header, Footer } from '../components';
import { PageTitle } from '../components/Text';
import { TwoRows } from '../components/Structure';
import ScrollToTop from '../components/Page/ScrollToTop';
import StepsMenu from '../components/StepsMenu';
import useGetSummaryDetails from '../hooks/useGetSummaryDetails';
import './SummaryScreen.scss';

const SummaryScreen = () => {
  const history = useHistory();
  const summaryDetails = useGetSummaryDetails();

  const categoriesSelected = summaryDetails.categories.renewCategories === 'all' ? <li>All categories and endorsements</li>
    : summaryDetails.categories.selectedCategories.map((category) => (
      <li key={category.code}>{category.code}: {category.name}</li>
    ));

  return (
    <>
      <ScrollToTop />
      <Header />
      <div id="main">
        <div className="container">
          <div className="content-wrap introduction">
            <StepsMenu />
            <PageTitle className="project-title">
              Summary
            </PageTitle>
            <div>
              <p className="summary__introduction">
                This is the summary of the Card Holders Application. Please check the details.
              </p>
            </div>
            <div className="primary-content">
              <p>
                <strong>Forename:</strong> {summaryDetails.forename}
              </p>
              <p>
                <strong>Surname:</strong> {summaryDetails.surname}
              </p>
              <p>
                <strong>Categories selected for renewal:</strong>
                <ul>
                  {categoriesSelected}
                </ul>
              </p>
              <p>
                <strong>Mailing address:</strong>
                {summaryDetails.mailingAddress.useHomeAddress ? <ul><li>Use home address</li></ul>
                  : (
                    <ul className="summary__mailing-address-list">
                      <li>
                        {summaryDetails.mailingAddress.mailingAddressLine1}
                      </li>
                      <li>
                        {summaryDetails.mailingAddress.mailingAddressLine2}
                      </li>
                      <li>
                        {summaryDetails.mailingAddress.mailingAddressLine3}
                      </li>
                      <li>
                        {summaryDetails.mailingAddress.mailingAddressLine4}
                      </li>
                      <li>
                        {summaryDetails.mailingAddress.mailingPostcode}
                      </li>
                    </ul>
                  )}
              </p>
              <TwoRows className="nav-buttons">
                <Button classButton="back" onPress={history.goBack}>
                  Back
                </Button>
                <button
                  className="button introduction__action-button"
                  type="button"
                >
                  <Link to="/evidence" className="link">
                    Next
                  </Link>
                </button>
              </TwoRows>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SummaryScreen;
